
import { useState } from 'react';

export default function BeforeAfter() {
  const cases = [
    {
      title: '1LDKマンション 遺品整理',
      before: 'https://public.readdy.ai/ai/img_res/030b4a1a202c07c57a419f3911a7a2a2.jpg',
      after: 'https://readdy.ai/api/search-image?query=Clean%20and%20organized%20Japanese%20apartment%20living%20room%20after%20estate%20clearing%2C%20showing%20empty%20spacious%20room%20with%20polished%20floors%2C%20clean%20walls%2C%20bright%20natural%20light%2C%20spotless%20condition%2C%20professional%20cleaning%20results%2C%20simple%20background%2C%20conveying%20fresh%20start%20and%20peace%20of%20mind&width=600&height=400&seq=after-1&orientation=landscape',
      duration: '作業時間：4時間',
      staff: 'スタッフ：3名'
    },
    {
      title: '2DK一戸建て 生前整理',
      before: 'https://readdy.ai/api/search-image?query=Overcrowded%20Japanese%20house%20room%20before%20life%20organization%2C%20filled%20with%20old%20furniture%2C%20clothing%2C%20books%2C%20and%20various%20items%20accumulated%20over%20years%2C%20realistic%20photography%2C%20simple%20background%2C%20showing%20the%20challenge%20of%20downsizing%20and%20decluttering&width=600&height=400&seq=before-2&orientation=landscape',
      after: 'https://readdy.ai/api/search-image?query=Neat%20and%20tidy%20Japanese%20house%20room%20after%20life%20organization%2C%20showing%20well-organized%20space%20with%20essential%20items%20neatly%20arranged%2C%20clean%20floors%2C%20bright%20atmosphere%2C%20comfortable%20living%20environment%2C%20simple%20background%2C%20emphasizing%20improved%20quality%20of%20life&width=600&height=400&seq=after-2&orientation=landscape',
      duration: '作業時間：6時間',
      staff: 'スタッフ：4名'
    },
    {
      title: '3LDKマンション ゴミ屋敷片付け',
      before: 'https://readdy.ai/api/search-image?query=Severely%20cluttered%20Japanese%20apartment%20room%20with%20excessive%20garbage%2C%20trash%20bags%2C%20scattered%20items%2C%20and%20debris%20covering%20the%20floor%2C%20challenging%20hoarding%20situation%2C%20realistic%20photography%2C%20simple%20background%2C%20showing%20the%20severity%20before%20professional%20intervention&width=600&height=400&seq=before-3&orientation=landscape',
      after: 'https://readdy.ai/api/search-image?query=Completely%20transformed%20Japanese%20apartment%20room%20after%20hoarding%20cleanup%2C%20showing%20pristine%20clean%20empty%20space%2C%20shining%20floors%2C%20fresh%20white%20walls%2C%20bright%20natural%20light%2C%20professional%20deep%20cleaning%20results%2C%20simple%20background%2C%20conveying%20hope%20and%20new%20beginning&width=600&height=400&seq=after-3&orientation=landscape',
      duration: '作業時間：8時間',
      staff: 'スタッフ：5名'
    }
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="py-20 bg-gradient-to-b from-white to-pink-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">作業実績</h2>
          <p className="text-lg text-gray-600">
            どのような状態のお部屋でも、丁寧に整理いたします
          </p>
        </div>

        <div className="mb-8 flex justify-center gap-4 flex-wrap">
          {cases.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`px-6 py-3 rounded-full font-bold transition-colors whitespace-nowrap ${
                activeIndex === index
                  ? 'bg-green-600 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              事例 {index + 1}
            </button>
          ))}
        </div>

        <div className="bg-gradient-to-br from-pink-50 to-white rounded-2xl shadow-xl overflow-hidden border border-pink-100">
          <div className="p-8">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
              {cases[activeIndex].title}
            </h3>
            
            <div className="grid md:grid-cols-2 gap-8 mb-6">
              <div>
                <div className="bg-red-100 text-red-800 font-bold px-4 py-2 rounded-t-lg text-center">
                  作業前
                </div>
                <div className="border-4 border-red-100 rounded-b-lg overflow-hidden">
                  <img 
                    src={cases[activeIndex].before}
                    alt="作業前"
                    className="w-full h-80 object-cover object-top"
                  />
                </div>
              </div>
              
              <div>
                <div className="bg-green-100 text-green-800 font-bold px-4 py-2 rounded-t-lg text-center">
                  作業後
                </div>
                <div className="border-4 border-green-100 rounded-b-lg overflow-hidden">
                  <img 
                    src={cases[activeIndex].after}
                    alt="作業後"
                    className="w-full h-80 object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-center gap-8 text-gray-700">
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-green-600 text-xl w-5 h-5 flex items-center justify-center"></i>
                <span className="font-medium">{cases[activeIndex].duration}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-team-line text-green-600 text-xl w-5 h-5 flex items-center justify-center"></i>
                <span className="font-medium">{cases[activeIndex].staff}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
